import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { Container } from '@material-ui/core';
import { ItemIcon } from '../../Home/Sections/OurOffer/OurOffer.styles';
import { FakeItemsStyleProps } from './NoDovePoints.interface';

export const StyledContainer = styled(Container)`
    && {
        margin-top: ${({ theme }) => theme.spacing * 25}px;
    }
`;

export const Element = styled.div<FakeItemsStyleProps>`
    opacity: ${props => props.opacity};
    @media screen and (max-width: 690px) {
        width: 100%;
    }
`;

export const ElementTitle = styled.div`
    width: 200px;
    height: 12px;
    background-color: #C8D1DC;
    margin-bottom: ${({ theme }) => theme.spacing * 7}px;
`;

export const ElementName = styled.div`
    width: 100px;
    height: 8px;
    background-color: #C8D1DC;
    margin-right: ${({ theme }) => theme.spacing * 9}px;
    margin-bottom: ${({ theme }) => theme.spacing * 6}px;
    @media screen and (max-width: 690px) {
        width: 20%;
    }
`;

export const ElementDescription = styled.div`
    width: 220px;
    height: 8px;
    background-color: #E1E7ED;
    margin-bottom: ${({ theme }) => theme.spacing * 6}px;
    @media screen and (max-width: 690px) {
        width: 80%;
    }
`;

export const FlexWrapper = styled.div`
    display: flex;
    align-items: center;
`;

export const GridWrapper = styled.div`
    display: grid;
    grid-template-columns: auto auto;
    justify-content: start;
    grid-column-gap: 80px;
    grid-row-gap: 60px;
    margin-top: ${({ theme }) => theme.spacing * 10}px;
    @media screen and (max-width: 960px) {
        grid-template-columns: 100%;
    }
`;

export const StyledItemIcon = styled(ItemIcon)`
    height: 60px;
    width: 60px;
`;

export const Title = styled.h1`
    font-size: 36px;
    line-height: 48px;
    margin: 0 0 ${({ theme }) => theme.spacing * 10}px;
    color: ${({ theme }) => theme.colors.blue};
    font-weight: normal;
`;

export const StyledLink = styled(Link)`
    width: 100%;
    height: 44px;
    color: ${({ theme }) => theme.colors.white};
    background-color: ${({ theme }) => theme.colors.primary};
    font-weight: bold;
    border-radius: 6px;
    line-height: 44px;
    display: block;
    text-decoration: none;
    text-transform: uppercase;
    text-align: center;
    font-size: 12px;
    margin-top: ${({ theme }) => theme.spacing * 10}px;
`;

export const Description = styled.p`
    line-height: 24px;
    color: ${({ theme }) => theme.colors.blue};
`;

export const Wrapper = styled.div`
    display: grid;
    grid-template-columns: 60px auto;
    grid-column-gap: 16px;
    align-items: center;
`;

export const Button = styled.button`
    border: none;
    outline: none;
    cursor: pointer;
    width: 100%;
    height: 44px;
    color: ${({ theme }) => theme.colors.white};
    background-color: ${({ theme }) => theme.colors.primary};
    font-weight: bold;
    border-radius: 6px;
    line-height: 44px;
    text-transform: uppercase;
    font-size: 12px;
    margin-top: ${({ theme }) => theme.spacing * 10}px;
`;
